import React from "react";
import { makeStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import TablePaginationActions from "../../shared/components/Table/Actions";
import Button from "../UI/Button";
import Loading from "../UI/Loading";
import { dateTimeFormat } from "../../util/DateUtil";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  novoRegistro: {
    marginTop: "10px",
    marginBottom: "10px",
  },
  cursorLink: {
    cursor: "pointer",
  },
  rowHeader: {
    fontSize: 13,
    fontWeight: "700",
  },
});

const InstituicaoTable = ({
  pageInstituicoes,
  handleChangePage,
  setInstituicao,
  isLoading,
}) => {
  const classes = useStyles();

  return (
    <div>
      {isLoading ? (
        <Loading description="Carregando Instituições..." />
      ) : (
        <>
          <Button
            onClick={() => setInstituicao({ eNovo: true })}
            className={classes.novoRegistro}
          >
            Nova Instituição
          </Button>
          <Table
            className={classes.table}
            size="small"
            aria-label="a dense table"
          >
            <TableHead>
              <TableRow>
                <TableCell className={classes.rowHeader}>Descrição</TableCell>
                <TableCell className={classes.rowHeader}>CPF / CNPJ</TableCell>
                <TableCell className={classes.rowHeader}>Endereço</TableCell>
                <TableCell className={classes.rowHeader}>Bairro</TableCell>
                <TableCell className={classes.rowHeader}>Cidade</TableCell>
                <TableCell className={classes.rowHeader}>Estado</TableCell>
                <TableCell className={classes.rowHeader}>Criado Em</TableCell>
                <TableCell className={classes.rowHeader}>
                  Última Atualização
                </TableCell>
                <TableCell className={classes.rowHeader}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pageInstituicoes.content.map((instituicao) => (
                <TableRow key={instituicao.codigo}>
                  <TableCell>
                    {instituicao.descricao ? instituicao.descricao : ""}
                  </TableCell>
                  <TableCell>
                    {instituicao.cpfCnpj ? instituicao.cpfCnpj : ""}
                  </TableCell>
                  <TableCell>
                    {instituicao.endereco ? instituicao.endereco : ""}
                  </TableCell>
                  <TableCell>
                    {instituicao.bairro ? instituicao.bairro : ""}
                  </TableCell>
                  <TableCell>
                    {instituicao.cidade ? instituicao.cidade : ""}
                  </TableCell>
                  <TableCell>
                    {instituicao.estado ? instituicao.estado : ""}
                  </TableCell>
                  <TableCell>
                    {instituicao.createdAt
                      ? dateTimeFormat(instituicao.createdAt)
                      : ""}
                  </TableCell>
                  <TableCell>
                    {instituicao.lastModified
                      ? dateTimeFormat(instituicao.lastModified)
                      : ""}
                  </TableCell>
                  <TableCell>
                    <Button
                      fontSize="small"
                      className={classes.cursorLink}
                      onClick={() => setInstituicao(instituicao)}
                      color="secondary"
                      style={{ marginRight: "10px" }}
                    >
                      Selecionar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[]}
            rowsPerPage={pageInstituicoes.size ? pageInstituicoes.size : 0}
            component="div"
            count={pageInstituicoes.totalElements}
            page={pageInstituicoes.number}
            onPageChange={handleChangePage}
            labelDisplayedRows={({ from, to, count }) =>
              from +
              "-" +
              to +
              " de " +
              (count !== -1 ? count + " registros" : +" mais de " + to)
            }
            ActionsComponent={TablePaginationActions}
          />
        </>
      )}
    </div>
  );
};

export default InstituicaoTable;
